import React from 'react';
import { SocketIO } from '@goldfishcode/modern-groom-api-sdk';

export const AppSocketContext = React.createContext<SocketIO | null>(null);
